/*
Monotype Foundry Platform API
Version 1.0.0

Definition: BulkImportStatusResponse

Properties:
  fileSuccess: boolean
  importStatus: array
  message: string
  owner: string
  success: boolean
  tempImportVersion: string
*/

var BulkImportStatusResponse = (function () {
  function validateBulkImportStatusResponse (arg) {
    // Validate fileSuccess
    if (arg.fileSuccess && !(typeof arg.fileSuccess === 'boolean')) {
      throw new Error('BulkImportStatusResponse.fileSuccess: Wrong type: Got \'' + (typeof arg.fileSuccess) + '\', but expected: \'boolean\'')
    }
    // Validate message
    if (arg.message && !(typeof arg.message === 'string')) {
      throw new Error('BulkImportStatusResponse.message: Wrong type: Got \'' + (typeof arg.message) + '\', but expected: \'string\'')
    }
    // Validate owner
    if (arg.owner && !(typeof arg.owner === 'string')) {
      throw new Error('BulkImportStatusResponse.owner: Wrong type: Got \'' + (typeof arg.owner) + '\', but expected: \'string\'')
    }
    // Validate success
    if (arg.success && !(typeof arg.success === 'boolean')) {
      throw new Error('BulkImportStatusResponse.success: Wrong type: Got \'' + (typeof arg.success) + '\', but expected: \'boolean\'')
    }
  }
  function buildBulkImportStatusResponse (arg) {
    var BulkImportStatusResponse = arg
    // Complete fileSuccess
    // Expected Type: boolean
    BulkImportStatusResponse.fileSuccess = BulkImportStatusResponse.fileSuccess || false
    // Complete message
    // Expected Type: string
    BulkImportStatusResponse.message = BulkImportStatusResponse.message || ''
    // Complete owner
    // Expected Type: string
    BulkImportStatusResponse.owner = BulkImportStatusResponse.owner || ''
    // Complete success
    // Expected Type: boolean
    BulkImportStatusResponse.success = BulkImportStatusResponse.success || false
    return BulkImportStatusResponse
  }
  return {
    validate: validateBulkImportStatusResponse,
    build: buildBulkImportStatusResponse
  }
})()

module.exports = BulkImportStatusResponse
